import { type ComponentPropsWithoutRef } from 'react';
import { breakpoints, Stack, vars } from '@etg/wings';
import { css, cx } from '@eti/styles';
import { useSearchFormBackgroundImage } from '../../utils/backgroundImage';

const sectionStyles = css`
  background-color: ${vars.colors.panel.background};
  display: flex;
  padding-inline: 10px;
  place-content: center;
  place-items: center;
  position: relative;
  width: 100%;

  @media (min-width: ${breakpoints._768}) {
    background-color: ${vars.colors.page.background.primary};
    padding-inline: 16px;
  }

  &::before {
    @media (min-width: ${breakpoints._768}) {
      background-image: linear-gradient(0deg, rgb(0 0 0 / 90%), 30%, rgb(0 0 0 / 5%));
      content: '';
      display: grid;
      height: 100%;
      place-content: center;
      position: absolute;
      width: 100%;
    }
  }
`;

const contentStyles = css`
  padding-block: 32px 24px;
  position: relative;
  width: 100%;

  @media (min-width: ${breakpoints._768}) {
    padding-block: 40px 64px;
  }

  @media (min-width: ${breakpoints._1024}) {
    max-width: 59.375rem;
    padding-block: 56px 96px;
  }
`;

const SearchFormSection = ({ children, ...rest }: ComponentPropsWithoutRef<'section'>) => {
  const { cssClass } = useSearchFormBackgroundImage();

  return (
    <section className={cx(sectionStyles, cssClass)} {...rest}>
      <Stack
        className={contentStyles}
        spacing={{ [breakpoints._0]: 24, [breakpoints._768]: 32, [breakpoints._1024]: 40 }}
      >
        {children}
      </Stack>
    </section>
  );
};

export default SearchFormSection;
